import { TFC } from '@ftd/types'
import { Container, ContainerProps } from '@mantine/core'

export const PageTemplate: TFC<ContainerProps> = ({ children, ...containerProps }) => (
  <Container size="lg" mx="auto" px="lg" {...containerProps}>
    {children}
  </Container>
)
